import axios, { AxiosRequestConfig } from 'axios';

const win = window as Win;
const defaultConfig = {
  headers: {
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    'Access-Control-Allow-Methods': 'GET, POST, DELETE, OPTIONS',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  timeout: 60000,
  withCredentials: true,
  baseURL: process.env.REACT_APP_API || `${win.globalBaseUrl || ''}/view/api/v1`,
};

const searchParams = new URLSearchParams(win.location.search);
const AXIOS = axios.create(defaultConfig);
const moduleId =
  searchParams && searchParams.has('moduleId') ? searchParams.get('moduleId') : win.globalModuleId;

const session = 'session';

const get = (url: string, config?: AxiosRequestConfig) => {
  return AXIOS.get(`${url}`, config);
};

const post = (url: string, data?: unknown) => {
  return AXIOS.post(`${url}`, data);
};

// Litmos specific calls
export const getCourseForLearner = (courseId: string, learnerId: string) => {
  return get(`/learner/${learnerId || session}/course/${courseId}`);
};

export const getModuleForLearner = (learnerId: string) => {
  return get(`/learner/${learnerId || session}/module/${moduleId}`);
};

export const getResourceForLearner = ({
  learnerId,
  slideId,
  resourceId,
}: {
  learnerId: string;
  slideId: string;
  resourceId: string;
}) => {
  return get(
    `/learner/${learnerId || session}/module/${moduleId}/slide/${slideId}/resource/${resourceId}`,
  );
};

export const updateHideModuleExercisesForLearner = (learnerId: string, hideExercises: boolean) => {
  return post(`/learner/${learnerId || session}/module/${moduleId}/hideExercises`, {
    hideExercises,
  });
};

export const getSlideForLearner = ({
  learnerId,
  currentSlideId,
  loadSlideId,
}: {
  learnerId: string;
  currentSlideId?: string;
  loadSlideId: string;
}) => {
  return get(
    `/learner/${learnerId || session}/module/${moduleId}/slide/${loadSlideId}${
      currentSlideId ? '?previousSlideId=' + currentSlideId : ''
    }`,
  );
};

export const getNextSlideForLearner = ({
  learnerId,
  currentSlideId,
  navItemId,
}: {
  learnerId: string;
  currentSlideId?: string;
  navItemId?: string;
}) => {
  return get(
    `/learner/${learnerId || session}/module/${moduleId}${
      navItemId ? '/nav/' + navItemId : ''
    }/slide${currentSlideId ? '?previousSlideId=' + currentSlideId : ''}`,
  );
};

export const getPreviousSlideForLearner = ({
  learnerId,
  currentSlideId,
  navItemId,
}: {
  learnerId: string;
  currentSlideId: string;
  navItemId?: string;
}) => {
  return get(
    `/learner/${learnerId || session}/module/${moduleId}${
      navItemId ? '/nav/' + navItemId : ''
    }/slide/${currentSlideId}/previous`,
  );
};

export const updateStatusForLearner = (
  learnerId: string,
  slideId: string,
  lastActive: Date,
  isStart: boolean,
) => {
  return post(`/learner/${learnerId || session}/slide/${slideId}/status`, {
    lastActive,
    isStart,
  });
};

export const getStylesForLearner = () => {
  return get(`/style`);
};

export const markViewedForLearner = ({
  currentSlideId,
  learnerId,
}: {
  learnerId: string;
  currentSlideId: string;
}) => {
  return post(`/learner/${learnerId || session}/module/${moduleId}/slide/${currentSlideId}/viewed`);
};

export const sendFeedbackForLearner = (learnerId: string, slideId: string, data: unknown) => {
  return post(`/learner/${learnerId || session}/slide/${slideId}/feedback`, data);
};

export const submitSelectionForLearner = (
  learnerId: string,
  slideId: string,
  selected: string | ISelected | ISelected[],
) => {
  return post(`/learner/${learnerId || session}/slide/${slideId}/submit`, {
    selected,
  });
};

export const getPDFForLearner = (learnerId: string, resourceId: string) => {
  return get(`/learner/${learnerId || session}/pdf/${resourceId}`, {
    responseType: 'blob',
  });
};
